module.exports = __webpack_public_path__ + "img/djezzy.59692aba.svg";